import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FHETitle } from 'data/components';
import {
    SvgProduct,
    SvgSDM17SPG,
    SvgSDM18HCL,
    SvgSDM18MVR,
    SvgSDM18SP2,
    SvgSDM17DEC,
    SvgSDM18HCN,
    SvgAirzone,
    SvgSmokeDetector,
    SvgRemote
} from 'data/common/iconsvg';

class ProductTitle extends PureComponent {
    static propTypes = {
        homeLabel: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired
    };

    iconRender = () => {
        const { type } = this.props;

        switch (type) {
            case 'smoke_detector':
                return SvgSmokeDetector;
            case 'airzone':
                return SvgAirzone;
            case 'SDM17DEC':
                return SvgSDM17DEC;
            case 'SDM18HCN':
                return SvgSDM18HCN;
            case 'SDM18SP2':
                return SvgSDM18SP2;
            case 'SDM17SPG':
                return SvgSDM17SPG;
            case 'SDM18MVR':
                return SvgSDM18MVR;
            case 'SDM18HCL':
                return SvgSDM18HCL;
            case 'Remote':
                return SvgRemote;
            default:
                return SvgProduct;
        }
    };

    render() {
        const { homeLabel } = this.props;
        return <FHETitle title={homeLabel} Icon={this.iconRender()} />;
    }
}

export default ProductTitle;



// WEBPACK FOOTER //
// ./data/components/ProductTitle.js